.InstitutionBannerContainer {
  object-fit: cover;
  width: 100%;
  height: 25rem;
  padding: 1.5rem;
  position: relative;
  border-radius: 2rem;
  max-width: 1550px;
  margin: 0 auto;
}

.EventInstitutionCardContainer {
  position: absolute;
  right: 2rem;
  bottom: 2rem;
  width: 80%;
  @media (min-width: 1024px) {
    width: 45rem;
  }
}

.TabLayout {
  display: grid;
  grid-template-columns: minmax(12rem, 15rem) minmax(0, 1fr);
  gap: 1.25rem;
  align-items: start;
  margin-top: 1rem;
}

.FiltersPanel {
  position: sticky;
  top: 1rem;
}

.TabMain {
  min-width: 0;
}

@media (max-width: 991.98px) {
  .TabLayout {
    grid-template-columns: 1fr;
  }

  .FiltersPanel {
    position: static;
  }
}
